function applyNavigationToggler(element) {
    if (!element) return;

    const label = element.querySelector('.mNavigationToggler__Label');
    const body = document.querySelector(`body`);
    const {targetNavigation, toggleClass, labelShow, labelHide} = element.dataset;
    const navigation = document.querySelector(`#${targetNavigation}`);

    if (!navigation) return;

    element.addEventListener('click', (event) => {
        event.preventDefault();
        label.innerHTML = '';
        element.classList.add('mask');
        if (navigation.classList.contains(toggleClass)) {
            navigation.classList.remove(toggleClass);
            body.classList.remove(toggleClass);
            body.style.overflowY = 'scroll';
            setTimeout(() => {
                label.innerHTML = labelShow;
                element.classList.remove('mask');
            }, 190);
        } else {
            navigation.classList.add(toggleClass);
            body.classList.add(toggleClass);
            setTimeout(() => {
                body.style.overflowY = 'hidden';
                label.innerHTML = labelHide;
                element.classList.remove('mask');
            }, 190);
        }
    });

    document.addEventListener('click', (event) => {
        if (!navigation.classList.contains(toggleClass)) return;
        const withinBoundaries = event.composedPath().includes(navigation)

        if (!withinBoundaries) {
            navigation.classList.remove(toggleClass);
            body.classList.remove(toggleClass);
            body.style.overflowY = 'scroll';
        }
    });
}

export {applyNavigationToggler};
